

















// Scrolling automatico con i pulsanti (se necessario)
document.querySelectorAll('.carousel-items').forEach(carousel => {
  const leftButton = carousel.querySelector('.scroll-left');
  const rightButton = carousel.querySelector('.scroll-right');

  if (leftButton && rightButton) {
    leftButton.addEventListener('click', () => {
      carousel.scrollBy({ left: -300, behavior: 'smooth' });
    });
    rightButton.addEventListener('click', () => {
      carousel.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }
});














document.querySelectorAll('.product-details-new').forEach((element) => {
  element.addEventListener('mouseenter', () => {
    element.style.backgroundColor = '#f5f5f5'; /* Sfondo leggermente grigio al passaggio del mouse */
  });
  element.addEventListener('mouseleave', () => {
    element.style.backgroundColor = '#fff'; /* Torna al bianco */
  });
});










document.addEventListener("DOMContentLoaded", function() {
  const accordionButtons = document.querySelectorAll('.accordion-button');
  const sizeToggles = document.querySelectorAll('.size-toggle');
  const sizeTables = document.querySelectorAll('.size-table-container');

  // Gestione dell'accordion
  accordionButtons.forEach(button => {
    button.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const isOpen = content.classList.contains('open');

      if (!isOpen) {
        content.classList.add('open');
        this.classList.add('active');
      } else {
        content.classList.remove('open');
        this.classList.remove('active');
      }
    });
  });

  // Imposta la Size Guide come aperta di default
  const sizeGuideButton = document.querySelector('.accordion-button:nth-child(2)');
  const sizeGuideContent = sizeGuideButton.nextElementSibling;
  sizeGuideContent.classList.add('open');
  sizeGuideButton.classList.add('active');

  // Imposta la visualizzazione predefinita delle tabelle
  const inchesTable = document.querySelector('.inches-table');
  const centimetersTable = document.querySelector('.centimeters-table');
  inchesTable.style.display = 'block';
  centimetersTable.style.display = 'none';

  // Gestione toggle tra Inches e Centimeters
  sizeToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      // Rimuovi la classe 'active' da tutti i pulsanti
      sizeToggles.forEach(btn => btn.classList.remove('active'));

      // Aggiungi la classe 'active' al pulsante cliccato
      this.classList.add('active');

      const size = this.getAttribute('data-size');

      // Nascondi tutte le tabelle e mostra quella selezionata
      sizeTables.forEach(table => {
        if (table.classList.contains(size + '-table')) {
          table.style.display = 'block';
        } else {
          table.style.display = 'none';
        }
      });
    });
  });

  // Imposta il pulsante "Inches" come attivo di default
  const inchesToggle = document.querySelector('.size-toggle[data-size="inches"]');
  if (inchesToggle) {
    inchesToggle.classList.add('active');
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const sizeToggles = document.querySelectorAll('.size-toggle');
  const inchesTable = document.querySelector('.inches-table');
  const centimetersTable = document.querySelector('.centimeters-table');

  // Imposta la visualizzazione predefinita delle tabelle
  inchesTable.style.display = 'block';
  centimetersTable.style.display = 'none';

  // Gestione toggle tra Inches e Centimeters
  sizeToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      // Rimuovi la classe 'active' da tutti i pulsanti
      sizeToggles.forEach(btn => btn.classList.remove('active'));

      // Aggiungi la classe 'active' al pulsante cliccato
      this.classList.add('active');

      const size = this.getAttribute('data-size');

      // Mostra solo la tabella corrispondente al pulsante cliccato
      if (size === 'inches') {
        inchesTable.style.display = 'block';
        centimetersTable.style.display = 'none';
      } else if (size === 'centimeters') {
        inchesTable.style.display = 'none';
        centimetersTable.style.display = 'block';
      }
    });
  });

  // Imposta il pulsante "Inches" come attivo di default
  const inchesToggle = document.querySelector('.size-toggle[data-size="inches"]');
  if (inchesToggle) {
    inchesToggle.classList.add('active');
  }
});






















document.addEventListener("DOMContentLoaded", function () {
  const buyNowButton = document.querySelector('button[type="submit"]'); // Selezioniamo il bottone con "Buy your T-shirt now!"
  
  buyNowButton.addEventListener('click', function(event) {
    event.preventDefault(); // Impediamo il submit del form per il momento
    
    const sizeSection = document.querySelector('.t4s-swatch__list'); // La sezione delle taglie
    if (sizeSection) {
      window.scrollTo({
        top: sizeSection.offsetTop - 50, // Spostiamo la pagina sopra la sezione taglie
        behavior: 'smooth'
      });
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
    const sizeSelect = document.getElementById("custom-size-select");
    const xlOption = Array.from(sizeSelect.options).find(option => option.dataset.size === "XL" && !option.disabled);
    
    // Impostiamo il valore di default a "XL" o al primo disponibile
    if (xlOption) {
        sizeSelect.value = xlOption.value;
    } else {
        const firstAvailableOption = Array.from(sizeSelect.options).find(option => !option.disabled);
        if (firstAvailableOption) {
            sizeSelect.value = firstAvailableOption.value;
        }
    }

    // Aggiorna l'input nascosto del form con il valore del variant selezionato
    sizeSelect.addEventListener("change", function () {
        document.getElementById("custom-variant-id").value = sizeSelect.value;
    });

    // Imposta il valore iniziale
    document.getElementById("custom-variant-id").value = sizeSelect.value;
});










document.addEventListener("DOMContentLoaded", function () {
  const galleryMain = document.querySelector(".product-gallery-main");
  const radios = document.querySelectorAll(".gallery-radio");
  const indicators = document.querySelectorAll(".indicator");
  let currentIndex = 0;

  // Funzione per aggiornare gli indicatori
  function updateIndicators() {
    radios.forEach((radio, index) => {
      if (radio.checked) {
        indicators.forEach((indicator) => indicator.classList.remove("active"));
        indicators[index].classList.add("active");
        currentIndex = index;
      }
    });
  }

  // Aggiungi listener ai label degli indicatori
  indicators.forEach((indicator, index) => {
    indicator.addEventListener("click", () => {
      radios[index].checked = true;
      updateIndicators();
    });
  });

  // Swipe orizzontale per cambiare immagine
  let startX = 0;
  galleryMain.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  galleryMain.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;

    if (deltaX > 50) {
      // Swipe verso destra (immagine precedente)
      currentIndex = (currentIndex - 1 + radios.length) % radios.length;
    } else if (deltaX < -50) {
      // Swipe verso sinistra (immagine successiva)
      currentIndex = (currentIndex + 1) % radios.length;
    }
    radios[currentIndex].checked = true;
    updateIndicators();
  });

  // Aggiorna gli indicatori al caricamento della pagina
  updateIndicators();
});
